import { TDocument } from '@modules/documents';
import { TInitialApprovalUsers } from '@modules/documents/types';
import { TFile } from '@modules/files';

const getInitialApprovalUsers = (item: TDocument | TFile): TInitialApprovalUsers | undefined =>
  item.initialApprovalUsers;

export default getInitialApprovalUsers;
